export const Company = {
  r0f9sdJYRA: {
    name: "BORGES",
  },
  wuC4kdcppG: {
    name: "FERRAZ",
    //widget_id: 'wHVQOeNHck'//(localhost)  //jN2tXsdAOk (app.debtor)
    widget_id: "QFsTLkk6vz",
  },
  kvPPAlqQH7: {
    name: "TS-COBRA",
    widget_id: "bHheK2L9CN",
  },
  Q9QEDM: {
    name: "TS-COBRA",
    widget_id: "bHheK2L9CN",
  },
  DJLIEI: {
    name: "TS-COBRA",
  },
  P6f1uD7ebV: {
    name: "MORAIS",
    widget_id: "EUDIyNLHV0",
  },
  Vmd3AoiUuC: {
    name: "JMS",
  },
  LP8d6Sh4C9: {
    name: "SAMUEL",
  },
  FMEuv4kplC: {
    name: "STOCCO",
  },
  "5yvPulCDGd": {
    name: "MAC",
  },
  PU71V5: {
    name: "CRESPO",
  },
  JGqAqq2EPo: {
    name: "CARVALHO",
  },
  ryUldVde8s: {
    name: "GABARDO",
  },
  uEbWH2XNSJ: {
    name: "PEREZ",
  },
  "345W03": {
    name: "Camargo",
  },
  "EPFOVA": {
    name: "FERRAZ",
  },

};
